import { FinancialInsights, FinancialInsightsParams } from '@hum/types';
import { createQuery } from '../../utils';

export const getFinancialInsights = createQuery<
  FinancialInsights,
  FinancialInsightsParams
>(({ api, params }) =>
  api.get(`/v2/companies/${params.companyId}/financial_insights`)
);
